import Logo       from '../assets/Logo';
import Fr2000Logo from '../assets/certs/Fr2000Logo';
import IncertLogo from '../assets/certs/IncertLogo';
import AckreLogo  from '../assets/certs/AckreLogo';
import config from '../config';

const CERTS = [
  { label: 'FR2000', Comp: Fr2000Logo },
  { label: 'INCERT', Comp: IncertLogo },
  { label: 'SWEDAC', Comp: AckreLogo  },
];

export default function Footer({ navigate }) {
  return (
    <footer>

      {/* ── MAIN GRID ── */}
      <div className="footer-grid">

        {/* Logo + tagline */}
        <div>
          <span className="logo-svg foot-logo-svg">
            <Logo height={52} />
          </span>
          <p style={{ fontSize:'.85rem', color:'rgba(255,255,255,.6)', lineHeight:1.6, marginTop:10 }}>
            {config.footerDescription}
          </p>
        </div>

        {/* Nav */}
        <div>
          <div className="fh">Sidor</div>
          <ul className="fl">
            <li onClick={() => navigate('home')}>Hem</li>
            <li onClick={() => navigate('services')}>Tjänster</li>
            <li onClick={() => navigate('about')}>Om oss</li>
            <li onClick={() => navigate('contact')}>Kontakt</li>
          </ul>
        </div>

        {/* Certs */}
        <div>
          <div className="fh">Certifierade enligt</div>
          <div className="footer-certs">
            {CERTS.map(({ label, Comp }) => (
              <div key={label} style={{ textAlign:'center' }}>
                <div style={{
                  width:54, height:54, borderRadius:'50%', background:'#fff',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  overflow:'hidden', padding:5,
                  boxShadow:'0 2px 10px rgba(0,0,0,.3)',
                }}>
                  <Comp size={42} />
                </div>
                <div style={{ fontSize:'.5rem', letterSpacing:'1px', textTransform:'uppercase', color:'rgba(255,255,255,.4)', marginTop:5 }}>
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="fc">
          <div className="fh">Kontakt</div>
          <p>
            <a href={config.phoneHref}>{config.phone}</a><br />
            <a href={`mailto:${config.email}`}>{config.email}</a><br />
            {config.area}
          </p>
        </div>

      </div>

      {/* ── BOTTOM BAR ── */}
      <div className="fb3">
        <p>{config.copyright}</p>
        <p>{config.footerTagline}</p>
      </div>

    </footer>
  );
}
